export const LOADING_START = 'LOADING_START';
export const LOADING_STOP = 'LOADING_STOP';
export const SEND_DETAILS = 'SEND_DETAILS';
export const SEND_DETAILS_SUCCESS = 'SEND_DETAILS_SUCCESS';
export const SEND_DETAILS_FAIL = 'SEND_DETAILS_FAIL';
export const APPLY_TEAMMATES_FIELD = 'APPLY_TEAMMATES_FIELD';
export const ERROR_HIDE_ACTION = 'ERROR_HIDE_ACTION';
export const CHECK_EMAILS = 'CHECK_EMAILS';
export const CHECK_EMAILS_SUCCESS = 'CHECK_EMAILS_SUCCESS';
export const CHECK_EMAILS_FAIL = 'CHECK_EMAILS_FAIL';
export const CHECK_TEAM = 'CHECK_TEAM';
export const CHECK_TEAM_SUCCESS = 'CHECK_TEAM_SUCCESS';
export const CHECK_TEAM_FAIL = 'CHECK_TEAM_FAIL';




export const removeErrorAction = () => ({
  type: ERROR_HIDE_ACTION,
});

export const loadingStop = () => ({
  type: LOADING_STOP
})

export const sendDetails = (details) => ({
  type: SEND_DETAILS,
  details: details
})

export const sendDetailsSuccess = (result) => ({
  type: SEND_DETAILS_SUCCESS,
  result: result
})

export const sendDetailsFail = (error) => ({
  type: SEND_DETAILS_FAIL,
  error: error
})

export const loadingStart = () => ({
  type: LOADING_START
})

export const testSample = () => ({
  type: 'SAMPLE_ON'
})

export const testSampleOff = () => ({
  type: 'SAMPLE_OFF'
});
export const setCurrentEvent = (name) => ({
  type: 'SET_CURRENT_EVENT',
  name: name
});

export const switchApplyPopup = (show) => ({
  type: 'SWITCH_APPLY_POPUP',
  show: show
})

export const nextApplyStep = () => ({
  type: 'NEXT_STEP_APPLY',
})

export const applyTeamId = (id, name) => ({
  type: 'APPLY_TEAM_ID',
  id: id,
  name: name
})

export const applyUserCode = (code) => ({
  type: 'APPLY_USER_CODE',
  code: code,
})

export const prevApplyStep = () => ({
  type: 'PREV_STEP_APPLY',
})

export const applyTeammatesField = (add) => ({
  type: APPLY_TEAMMATES_FIELD,
  add: add
});

export const removeTeammatesField = (add) => ({
  type: "REMOVE_TEAMMATES_FIELD",
});


export const updateDetails = (name, value) => ({
  type: 'UPDATE_DETAILS',
  name: name,
  value: value
})

export const checkEmails = (emails) => ({
  type: CHECK_EMAILS,
  emails: emails,
})

export const checkEmailsSuccess = (emails) => ({
  type: CHECK_EMAILS_SUCCESS,
  emails: emails,
})

export const checkEmailsFail = (error) => ({
  type: CHECK_EMAILS_FAIL,
  error: error,
})

export const checkTeam = (name) => ({
  type: CHECK_TEAM,
  name: name,
})

export const checkTeamSuccess = (exists) => ({
  type: CHECK_TEAM_SUCCESS,
  exists: exists,
})

export const checkTeamFail = (error) => ({
  type: CHECK_TEAM_FAIL,
  error: error,
})



// WEBPACK FOOTER //
// ./src/actions/index.js